export const init = () => {
	const jsGallery = document.querySelectorAll('.js-gallery');
	const jsArrowsPrev = Array.from(document.querySelectorAll('.js-carousel-prev'));
	const jsArrowsNext = Array.from(document.querySelectorAll('.js-carousel-next'));

	Array.from(jsGallery).forEach((item, index) => {
		new Glider(item, {
			slidesToShow: 1,
			slidesToScroll: 1,
			draggable: false,
			scrollLock: true,
			arrows: {
				prev: jsArrowsPrev[index],
				next: jsArrowsNext[index],
			},
		});
	});
};
